var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPinmap = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.589 14.627 8 14l.41.627a.75.75 0 0 1-.821 0M9.5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.589 14.627 8 14c.41.627.412.627.412.627h.001l.004-.004.013-.008.048-.033.17-.118a17.5 17.5 0 0 0 2.391-2.057c1.28-1.325 2.711-3.282 2.711-5.498 0-1.505-.61-2.946-1.689-4.006A5.8 5.8 0 0 0 8 1.25c-1.52 0-2.982.593-4.061 1.653A5.61 5.61 0 0 0 2.25 6.909c0 2.216 1.432 4.173 2.71 5.498a17.6 17.6 0 0 0 2.562 2.175l.048.032.013.01.004.002zm-2.6-10.654A4.3 4.3 0 0 1 8 2.75c1.132 0 2.214.441 3.01 1.223a4.11 4.11 0 0 1 1.24 2.936c0 1.603-1.068 3.19-2.29 4.457A16 16 0 0 1 8 13.08a16 16 0 0 1-1.96-1.716C4.818 10.1 3.75 8.513 3.75 6.91c0-1.098.444-2.155 1.24-2.936z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPinmap);
export default ForwardRef;